// Single Product Image Pinch & Zoom
var containers = document.getElementsByClassName('image-wrap');
var images = document.getElementsByClassName('zoomable-image');

var initialDistances = [];
var initialScales = [];
var lastScales = [];
var lastTouches = [];
var isZoomed = []; // Flag to track whether the image has been zoomed

Array.from(containers).forEach(function(container, index) {
    initialDistances[index] = 0;
    initialScales[index] = 1;
    lastScales[index] = 1;
    lastTouches[index] = [];
    isZoomed[index] = false; // Initialize flag as false for each image

    container.addEventListener('touchstart', function(event) {
        if (event.touches.length === 2) {
            initialDistances[index] = Math.hypot(
                event.touches[0].pageX - event.touches[1].pageX,
                event.touches[0].pageY - event.touches[1].pageY
            );
            initialScales[index] = lastScales[index] || 1;
        } else if (event.touches.length === 1 && isZoomed[index]) {
            // Store initial touch position for panning
            lastTouches[index] = [event.touches[0].pageX, event.touches[0].pageY];
        }
    });

    container.addEventListener('touchmove', function(event) {
        if (event.touches.length === 2) {
            var currentDistance = Math.hypot(
                event.touches[0].pageX - event.touches[1].pageX,
                event.touches[0].pageY - event.touches[1].pageY
            );

            var scale = currentDistance / initialDistances[index] * initialScales[index];

            // Limiting the scale to avoid over-zooming
            if (scale > 1 && scale < 3) {
                images[index].style.transform = 'scale(' + scale + ')';
                lastScales[index] = scale;
                isZoomed[index] = true; // Set flag to indicate image has been zoomed
            }
        } else if (event.touches.length === 1 && lastTouches[index].length === 2 && isZoomed[index]) {
            // Calculate panning distance and apply it to the image position
            var deltaX = event.touches[0].pageX - lastTouches[index][0];
            var deltaY = event.touches[0].pageY - lastTouches[index][1];

            // Calculate the boundaries based on the image and container dimensions
            var imageRect = images[index].getBoundingClientRect();
            var containerRect = container.getBoundingClientRect();

            // Check if the image is still zoomed in enough to allow panning
            if (lastScales[index] > 1) {
                // Check and adjust the panning to stay within the container
                var newTransform = images[index].style.transform + ' translate(' + deltaX + 'px, ' + deltaY + 'px)';
                images[index].style.transform = newTransform;

                // Adjust the translation to stay within the horizontal boundaries
                if (imageRect.left + deltaX > containerRect.left) {
                    images[index].style.transform = 'translateX(' + (containerRect.left - imageRect.left) + 'px)';
                } else if (imageRect.right + deltaX < containerRect.right) {
                    images[index].style.transform = 'translateX(' + (containerRect.right - imageRect.right) + 'px)';
                }

                // Adjust the translation to stay within the vertical boundaries
                if (imageRect.top + deltaY > containerRect.top) {
                    images[index].style.transform = 'translateY(' + (containerRect.top - imageRect.top) + 'px)';
                } else if (imageRect.bottom + deltaY < containerRect.bottom) {
                    images[index].style.transform = 'translateY(' + (containerRect.bottom - imageRect.bottom) + 'px)';
                }
            }

            lastTouches[index] = [event.touches[0].pageX, event.touches[0].pageY];
        } else {
            // Allow default scrolling behavior if not actively zooming or panning
            return;
        }

        // Prevent default behavior to avoid unwanted scrolling on the page
        // event.preventDefault();
    });

    container.addEventListener('touchend', function() {
        initialDistances[index] = 0;
        initialScales[index] = lastScales[index];
        lastTouches[index] = [];
    });
});


const slider = document.querySelector('.slider'); // Replace with your slider element
let isPinching = false;
let startDistance = 0;

if(slider != null){
  slider.addEventListener('touchstart', (e) => {
    if (e.touches.length === 2) {
      isPinching = true;
      startDistance = getDistance(e.touches[0], e.touches[1]);
    }
  });

  slider.addEventListener('touchmove', (e) => {
    if (isPinching && e.touches.length === 2) {
      e.preventDefault(); // Prevent the slider from sliding
      const currentDistance = getDistance(e.touches[0], e.touches[1]);
  
      // Perform your zoom logic here
      const zoomFactor = currentDistance / startDistance;
      console.log('Zoom factor:', zoomFactor);
  
      // Optionally, update startDistance for smoother zooming
      startDistance = currentDistance;
    }
  });
  
  slider.addEventListener('touchend', (e) => {
    if (e.touches.length < 2) {
      isPinching = false; // Reset pinch state when fingers are lifted
    }
  });

}
 
function getDistance(touch1, touch2) {
  const dx = touch2.clientX - touch1.clientX;
  const dy = touch2.clientY - touch1.clientY;
  return Math.sqrt(dx * dx + dy * dy);
}

 


 

